import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../Header.js';
import '../../css/PushManagement/AdminPush.css';
// (선택) 엑셀 내보내기 유틸이 있으면 사용
// import { exportToExcel } from '../../utils/exportToExcel.js';

export default function AdminPushList({ apiBase = 'http://13.124.224.246:7778' }) {
  const navigate = useNavigate();

  // 데이터 원본/표시용
  const [allItems, setAllItems] = useState([]);
  const [items, setItems] = useState([]);

  // UI 상태
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 검색 상태
  const [searchTerm, setSearchTerm] = useState('');
  const [searchCategory, setSearchCategory] = useState('all');

  // 페이지네이션
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  // 초기 데이터 로드
  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${apiBase}/api/push?limit=500`);
      if (data.success) {
        const list = Array.isArray(data.items) ? data.items : [];
        // createdAt 최신순 정렬
        const sorted = list.sort(
          (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        setAllItems(sorted);
        setItems(sorted);
      } else {
        setError('데이터 로드 실패');
      }
    } catch (e) {
      setError(e?.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  // 검색 핸들러
  const handleSearch = () => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) {
      setItems(allItems);
      setCurrentPage(1);
      return;
    }
    const filtered = allItems.filter((n) => {
      const fields = {
        all: [n.title, n.body],
        title: [n.title],
        body: [n.body],
      };
      const targets = (fields[searchCategory] || []).filter(Boolean);
      return targets.some((v) => String(v).toLowerCase().includes(term));
    });
    setItems(filtered);
    setCurrentPage(1);
  };



  // 삭제
  const handleDelete = async (id) => {
    if (!window.confirm('이 알림 기록을 삭제할까요?')) return;
    try {
      await axios.delete(`${apiBase}/api/push/${id}`);
      setAllItems((prev) => prev.filter((i) => i._id !== id));
      setItems((prev) => prev.filter((i) => i._id !== id));
    } catch (e) {
      alert(e?.response?.data?.message || e.message);
    }
  };

  // 페이지네이션 계산
  const totalPages = useMemo(
    () => Math.ceil(items.length / itemsPerPage) || 1,
    [items.length]
  );
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentRows = items.slice(indexOfFirst, indexOfLast);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };
  const handlePageChange = (n) => setCurrentPage(n);

  return (
    <div className="push-container">
      <Header />
      <div className="push-content">
        <div className="push-topbar">
          <h1>푸시 알림 관리</h1>
        
        </div>

        {/* 검색 박스 */}
        <div className="push-search-box">
          <select
            className="search-category"
            value={searchCategory}
            onChange={(e) => setSearchCategory(e.target.value)}
            style={{ height: '48px' }}
          >
            <option value="all">전체</option>
            <option value="title">제목</option>
            <option value="body">내용</option>
          </select>

          <input
            type="text"
            placeholder="검색..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSearch();
            }}
          />

          <button className="search-button" onClick={handleSearch}>
            검색
          </button>
        </div>

        {loading ? (
          <div className="push-loading">불러오는 중…</div>
        ) : error ? (
          <p className="error-text">{error}</p>
        ) : (
          <>
            <table className="push-table">
              <thead>
                <tr>
                  <th>번호</th>
                  <th>제목</th>
                  <th>내용</th>
                  <th>발송일시</th>
                  <th>액션</th>
                </tr>
              </thead>
              <tbody>
                {currentRows.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="no-results">
                      존재하지 않습니다.
                    </td>
                  </tr>
                ) : (
                  currentRows.map((row, idx) => (
                    <tr key={row._id}>
                      <td>{idx + 1 + (currentPage - 1) * itemsPerPage}</td>
                      <td className="push-title-cell" title={row.title}>
                        {row.title}
                      </td>
                      <td className="push-body-cell" title={row.body}>
                        {row.body}
                      </td>
                      <td>
                        {row.createdAt
                          ? new Date(row.createdAt).toLocaleString()
                          : ''}
                      </td>
                      <td>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(row._id)}
                        >
                          삭제
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {/* 페이지네이션 */}
            <div className="push-pagination">
              <button
                className="push-pagination-btn"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                이전
              </button>

              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  className={`push-pagination-btn${
                    currentPage === i + 1 ? ' active' : ''
                  }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                className="push-pagination-btn"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                다음
              </button>
            </div>

        <button
            type="button"
            className="primary-btn"
            onClick={() => navigate('/push/create')}
          >
            푸시 알림 등록하기
          </button>
          </>
        )}
      </div>
    </div>
  );
}
